
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 9.4 6.1"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.7 6.1L0 1.4 1.4 0l3.3 3.3L8 0l1.4 1.4z","fill":"#747474"}})])
          )
        }
      }
    